var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSocTw(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icon-tw",
    "data-name": "icon-tw",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24.01 19.51",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "tw-icon") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "tw-cls-1",
    d: "M8.2,22.08a13.93,13.93,0,0,0,14-14c0-.21,0-.42,0-.64a9.78,9.78,0,0,0,2.46-2.55,9.92,9.92,0,0,1-2.83.78A5,5,0,0,0,24,2.92a9.86,9.86,0,0,1-3.13,1.2,4.93,4.93,0,0,0-8.4,4.49A14,14,0,0,1,2.32,3.47,4.92,4.92,0,0,0,3.85,10a4.88,4.88,0,0,1-2.24-.61v.06a4.93,4.93,0,0,0,3.95,4.83,4.89,4.89,0,0,1-2.22.08,4.92,4.92,0,0,0,4.6,3.42,9.9,9.9,0,0,1-6.12,2.12,11.48,11.48,0,0,1-1.17-.07A14,14,0,0,0,8.2,22.08",
    transform: "translate(-0.65 -2.57)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocTw);
export default __webpack_public_path__ + "static/media/soc-tw.986ee322f137f3efce7d0bcf0932be7c.svg";
export { ForwardRef as ReactComponent };